exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wf_or_divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.wf_or_divider .divider {\n  background-color: #94A3B8;\n}\n.wf_or_divider .div_text {\n  margin: 0 1rem;\n  text-transform: uppercase;\n}\n", ""]);

